import { Grid } from "@mui/material";
import FormField from "components/FormField/FormField";
import MDButton from "components/MDButton";
import MDSelect from "components/MDSelect/MDSelect";
import MDTypography from "components/MDTypography";
import Modal from "modules/Modal/Modal";
import { useContext, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { AreaCoverageContext } from "../forms/AreaCoverage";

const updateValues = (setValue, poundsPerCubicYard) => {
  setValue("attributes.poundsPerCubicYard", poundsPerCubicYard);
};

const productActions = {
  "3-8-crushed-stone": (setValue, setAllowManualEdit) => {
    updateValues(setValue, "2700");
    setAllowManualEdit(false);
  },
  "3-8-washed-crushed-stone": (setValue, setAllowManualEdit) => {
    updateValues(setValue, "2700");
    setAllowManualEdit(false);
  },
  "1-2-crushed-stone": (setValue, setAllowManualEdit) => {
    updateValues(setValue, "2700");
    setAllowManualEdit(false);
  },
  "1-2-washed-crushed-stone": (setValue, setAllowManualEdit) => {
    updateValues(setValue, "2700");
    setAllowManualEdit(false);
  },
  "3-4-crushed-stone": (setValue, setAllowManualEdit) => {
    updateValues(setValue, "2700");
    setAllowManualEdit(false);
  },
  "3-4-washed-crushed-stone": (setValue, setAllowManualEdit) => {
    updateValues(setValue, "2700");
    setAllowManualEdit(false);
  },
  "1-1-2-crushed-stone": (setValue, setAllowManualEdit) => {
    updateValues(setValue, "2700");
    setAllowManualEdit(false);
  },
  "1-1-2-washed-crushed-stone": (setValue, setAllowManualEdit) => {
    updateValues(setValue, "2700");
    setAllowManualEdit(false);
  },
  "ballast-stone": (setValue, setAllowManualEdit) => {
    updateValues(setValue, "2600");
    setAllowManualEdit(false);
  },
  "choke-stone-1-3": (setValue, setAllowManualEdit) => {
    updateValues(setValue, "2900");
    setAllowManualEdit(false);
  },
  "drainage-stone-2-4": (setValue, setAllowManualEdit) => {
    updateValues(setValue, "2700");
    setAllowManualEdit(false);
  },
  "1-2-dense-graded-base": (setValue, setAllowManualEdit) => {
    updateValues(setValue, "3300");
    setAllowManualEdit(false);
  },
  custom: (setValue, setAllowManualEdit) => {
    setAllowManualEdit(true);
  },
};

const productOptions = [
  { label: '3/8" Crushed Stone', value: "3-8-crushed-stone" },
  { label: '3/8" Washed Crushed Stone', value: "3-8-washed-crushed-stone" },
  { label: '1/2" Crushed Stone', value: "1-2-crushed-stone" },
  { label: '1/2" Washed Crushed Stone', value: "1-2-washed-crushed-stone" },
  { label: '3/4" Crushed Stone', value: "3-4-crushed-stone" },
  { label: '3/4" Washed Crushed Stone', value: "3-4-washed-crushed-stone" },
  { label: '1 1/2" Crushed Stone', value: "1-1-2-crushed-stone" },
  { label: '1 1/2" Washed Crushed Stone', value: "1-1-2-washed-crushed-stone" },
  { label: "Ballast Stone", value: "ballast-stone" },
  { label: 'Choke Stone 1" - 3"', value: "choke-stone-1-3" },
  { label: 'Drainage Stone 2" - 4"', value: "drainage-stone-2-4" },
  { label: '1/2" Dense Graded Base', value: "1-2-dense-graded-base" },
  { label: "Custom", value: "custom" },
];

export default function GradingCalculateAreaModal() {
  const { calculateAreaCoverage, areaProduct, setAreaProduct } = useContext(AreaCoverageContext);
  const [isAllowedToEdit, setIsAllowedToEdit] = useState(false);
  const isNotAllowedToEdit = !isAllowedToEdit;

  const {
    control,
    getValues,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    calculateAreaCoverage(getValues, setValue);
  };

  return (
    <>
      <Modal onClose={handleClose} open={open}>
        <div style={{ position: "relative" }}>
          <Grid p={4} container spacing={3}>
            <Grid item xs={12}>
              <MDTypography>Calculate Area Coverage</MDTypography>
            </Grid>
            <Grid item xs={12}>
              <MDSelect
                fullWidth
                label="Select Product"
                name="areaProduct"
                options={productOptions}
                onChange={(e) => {
                  setAreaProduct(e.target.value);
                  const action = productActions[e.target.value];
                  if (action) {
                    action(setValue, setIsAllowedToEdit);
                  }
                }}
                value={areaProduct}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="attributes.poundsPerCubicYard"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <FormField
                    disabled={isNotAllowedToEdit}
                    type="number"
                    label="Pounds Per Cubic Yard"
                    placeholder="Pounds Per Cubic Yard"
                    name="attributes.poundsPerCubicYard"
                    error={error}
                    shrink
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDButton variant="gradient" color="secondary" onClick={handleClose}>
                Calculate Area Coverage
              </MDButton>
            </Grid>
          </Grid>
        </div>
      </Modal>
      <MDButton onClick={handleOpen} color="blue">
        Select Material to Calculate Coverage
      </MDButton>
    </>
  );
}
